import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import { Box,Button,Collapse,Divider,Drawer,Stack,Typography } from "@mui/material";
import { useEffect,useState } from "react";
import { useLocation,useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";

const SIDEBAR_WIDTH=260;

export default function Sidebar({ mobileOpen,onClose,organization }) {
  const navigate=useNavigate();
  const location=useLocation();
  const { logoutUser }=useAuth();
  const [usersOpen,setUsersOpen]=useState(false);
  const [accessOpen,setAccessOpen]=useState(false);
  const [sessionUser,setSessionUser]=useState(null);

  useEffect(()=>{
    try{
      const savedUser=localStorage.getItem("user_data");
      if(!savedUser){
        setSessionUser(null);
        return;
      }
      setSessionUser(JSON.parse(savedUser));
    }catch{
      setSessionUser(null);
    }
  },[location.pathname]);

  useEffect(()=>{
    if(location.pathname.startsWith("/usuarios")||location.pathname.startsWith("/roles"))setUsersOpen(true);
    if(location.pathname.startsWith("/accesos")||location.pathname.startsWith("/horarios")||location.pathname.startsWith("/permisos-roles")||location.pathname.startsWith("/permisos-usuarios"))setAccessOpen(true);
  },[location.pathname]);

  const handleNavigate=(path)=>{
    navigate(path);
    onClose?.();
  };

  const handleLogout=()=>{
    setUsersOpen(false);
    setAccessOpen(false);
    setSessionUser(null);
    onClose?.();
    logoutUser();
  };

  const isActive=(path)=>location.pathname===path;

  const menuButtonStyles=(path)=>{
    const active=isActive(path);
    return {
      justifyContent:"flex-start",
      minHeight:46,
      paddingX:2,
      borderRadius:2,
      color:"#ffffff",
      fontSize:14,
      fontWeight:800,
      textTransform:"none",
      backgroundColor:active?"#b00020":"#111111",
      border:"1px solid",
      borderColor:active?"#b00020":"#1f2937",
      "&:hover":{
        backgroundColor:active?"#92001a":"rgba(255,255,255,0.08)",
        borderColor:active?"#92001a":"rgba(255,255,255,0.18)"
      }
    };
  };

  const parentButtonStyles=(active)=>({
    justifyContent:"flex-start",
    minHeight:46,
    paddingX:2,
    borderRadius:2,
    color:"#ffffff",
    fontSize:14,
    fontWeight:800,
    textTransform:"none",
    backgroundColor:"#111111",
    border:"1px solid",
    borderColor:active?"#b00020":"#1f2937",
    "& .MuiButton-endIcon":{
      marginLeft:"auto",
      color:"#b00020"
    },
    "&:hover":{
      backgroundColor:"#171717",
      borderColor:active?"#b00020":"rgba(255,255,255,0.18)"
    }
  });

  const submenuButtonStyles=(path)=>{
    const active=isActive(path);
    return {
      justifyContent:"flex-start",
      minHeight:42,
      paddingX:2,
      borderRadius:2,
      color:active?"#ffffff":"#e5e7eb",
      fontSize:13,
      fontWeight:800,
      textTransform:"none",
      backgroundColor:active?"#b00020":"#181818",
      border:"1px solid",
      borderColor:active?"#b00020":"#2a2a2a",
      "&:hover":{
        backgroundColor:active?"#92001a":"#242424",
        borderColor:active?"#92001a":"#3a3a3a"
      }
    };
  };

  const usersSectionActive=location.pathname.startsWith("/usuarios")||location.pathname.startsWith("/roles");
  const accessSectionActive=location.pathname.startsWith("/accesos")||location.pathname.startsWith("/horarios")||location.pathname.startsWith("/permisos-roles")||location.pathname.startsWith("/permisos-usuarios");

  const content=(
    <Box sx={{ width:SIDEBAR_WIDTH,height:"100%",display:"flex",flexDirection:"column",backgroundColor:"#000000",color:"#ffffff",padding:2.5,overflowY:"auto" }}>
      <Stack spacing={1.5} alignItems="center">
        {organization?.logo?(
          <Box component="img" src={organization.logo} alt={organization.name||"Organización"} sx={{ width:96,height:96,flexShrink:0,borderRadius:3,objectFit:"cover",backgroundColor:"#ffffff",border:"4px solid #b00020",padding:0.5 }} />
        ):(
          <Box sx={{ width:96,height:96,flexShrink:0,borderRadius:3,display:"flex",alignItems:"center",justifyContent:"center",backgroundColor:"#ffffff",color:"#000000",border:"4px solid #b00020",fontSize:30,fontWeight:800 }}>
            {(organization?.name||"O").charAt(0).toUpperCase()}
          </Box>
        )}
        <Box sx={{ width:"100%",minWidth:0 }}>
          <Typography sx={{ fontSize:16,fontWeight:800,textAlign:"center",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis" }}>
            {organization?.name||"Organización"}
          </Typography>
          <Typography sx={{ marginTop:0.5,color:"#9ca3af",fontSize:12,fontWeight:700,textAlign:"center",wordBreak:"break-word" }}>
            {sessionUser?.email||"Sin correo"}
          </Typography>
        </Box>
      </Stack>
      <Divider sx={{ marginY:3,borderColor:"rgba(255,255,255,0.14)" }} />
      <Stack spacing={1}>
        <Button variant="text" onClick={()=>handleNavigate("/inicio")} sx={menuButtonStyles("/inicio")}>Inicio</Button>
        <Button variant="text" onClick={()=>setUsersOpen((current)=>!current)} endIcon={usersOpen?<KeyboardArrowUpRoundedIcon />:<KeyboardArrowDownRoundedIcon />} sx={parentButtonStyles(usersSectionActive)}>Usuarios y roles</Button>
        <Collapse in={usersOpen} timeout="auto" unmountOnExit>
          <Stack spacing={0.8} sx={{ marginLeft:1,paddingLeft:1.5,borderLeft:"3px solid #b00020" }}>
            <Button variant="text" onClick={()=>handleNavigate("/usuarios")} sx={submenuButtonStyles("/usuarios")}>Usuarios</Button>
            <Button variant="text" onClick={()=>handleNavigate("/roles")} sx={submenuButtonStyles("/roles")}>Roles</Button>
          </Stack>
        </Collapse>
        <Button variant="text" onClick={()=>setAccessOpen((current)=>!current)} endIcon={accessOpen?<KeyboardArrowUpRoundedIcon />:<KeyboardArrowDownRoundedIcon />} sx={parentButtonStyles(accessSectionActive)}>Control de acceso</Button>
        <Collapse in={accessOpen} timeout="auto" unmountOnExit>
          <Stack spacing={0.8} sx={{ marginLeft:1,paddingLeft:1.5,borderLeft:"3px solid #b00020" }}>
            <Button variant="text" onClick={()=>handleNavigate("/accesos")} sx={submenuButtonStyles("/accesos")}>Accesos</Button>
            <Button variant="text" onClick={()=>handleNavigate("/horarios")} sx={submenuButtonStyles("/horarios")}>Horarios</Button>
            <Button variant="text" onClick={()=>handleNavigate("/permisos-roles")} sx={submenuButtonStyles("/permisos-roles")}>Permisos por rol</Button>
            <Button variant="text" onClick={()=>handleNavigate("/permisos-usuarios")} sx={submenuButtonStyles("/permisos-usuarios")}>Permisos individuales</Button>
          </Stack>
        </Collapse>
        <Button variant="text" onClick={()=>handleNavigate("/asistencias")} sx={menuButtonStyles("/asistencias")}>Asistencias</Button>
      </Stack>
      <Box sx={{ flexGrow:1,minHeight:24 }} />
      <Button variant="contained" onClick={handleLogout} disableElevation sx={{ minHeight:46,justifyContent:"flex-start",paddingX:2,borderRadius:2,color:"#ffffff",backgroundColor:"#dc2626",fontSize:14,fontWeight:800,textTransform:"none","&:hover":{ backgroundColor:"#b91c1c" } }}>Cerrar sesión</Button>
    </Box>
  );

  return (
    <>
      <Box component="aside" sx={{ width:SIDEBAR_WIDTH,flexShrink:0,display:{ xs:"none",md:"block" } }}>
        <Box sx={{ position:"fixed",top:0,left:0,width:SIDEBAR_WIDTH,height:"100vh" }}>{content}</Box>
      </Box>
      <Drawer open={mobileOpen} onClose={onClose} ModalProps={{ keepMounted:true }} sx={{ display:{ xs:"block",md:"none" },"& .MuiDrawer-paper":{ width:SIDEBAR_WIDTH,border:0,backgroundColor:"#000000" } }}>
        {content}
      </Drawer>
    </>
  );
}